import CachedIcon from '@mui/icons-material/Cached'
import LoopIcon from '@mui/icons-material/Loop'
import ScheduleIcon from '@mui/icons-material/Schedule'
import { useSyncExternalStore } from 'react'
import { useAppSelector } from 'shared/hooks'
import { Observer } from 'shared/observer'
import { typo } from 'shared/styles'

import { api } from '../../api'
import { useCurrentId } from '../../hooks'
import { selectors } from '../../utils/selectors'
import css from './FilterForm.module.scss'

const actionCn = `${css.tempBtn} ${typo.buttonSmB}`

const isSynced = new Observer(false)

export const useIsPulling = () =>
	useSyncExternalStore(isSynced.subscribe, () => isSynced.value)

export function TempDebugButton() {
	const conversation = useCurrentId()

	const filter = useAppSelector(selectors.filter),
		search = useAppSelector(selectors.search)

	const isOn = useIsPulling()

	const list = api.endpoints.conversations.useQueryState({ filter, search })
	const messages = api.endpoints.messages.useQueryState(conversation)
	const unread = api.endpoints.unread.useQueryState()

	return (
		<button
			className={actionCn}
			onClick={() => {
				const old = isSynced.value
				isSynced.value = !old
			}}
			type='button'
		>
			{isOn ? (
				list.isFetching || messages.isFetching || unread.isFetching ? (
					<CachedIcon className={css.rotate} />
				) : (
					<ScheduleIcon />
				)
			) : (
				<LoopIcon />
			)}
			{isOn ? 'Stop' : 'Start'} sync
		</button>
	)
}
